import CONNECT from './queries/Connect.gql'
import RECONNECT from './queries/Reconnect.gql'
import UPDATE_CONNECTION from './queries/UpdateConnection.gql'
import {authClient, axios} from '@/main'

export default class {
    async connect (websiteId, connectionId, accountId, propertyId, measurementId, apiSecret, isEnabledLPTracking, sendRefunds, pageDataOption) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: CONNECT,
            variables: {
                connectionId: connectionId,
                websiteId: websiteId,
                accountId: accountId,
                propertyId: propertyId,
                measurementId: measurementId,
                apiSecret: apiSecret,
                isEnabledLPTracking: isEnabledLPTracking,
                sendRefunds: sendRefunds,
                pageDataOption: pageDataOption
            }
        })
    }

    async updateConnection (websiteId, isEnabledLPTracking, sendRefunds, pageDataOption) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: UPDATE_CONNECTION,
            variables: {
                websiteId: websiteId,
                isEnabledLPTracking: isEnabledLPTracking,
                sendRefunds: sendRefunds,
                pageDataOption: pageDataOption
            }
        })
    }

    async reconnect (websiteId, connectionId, accountId, propertyId, measurementId, apiSecret) {
        return await authClient.mutate({
            client: 'authClient',
            mutation: RECONNECT,
            variables: {
                websiteId: websiteId,
                connectionId: connectionId,
                accountId: accountId,
                propertyId: propertyId,
                measurementId: measurementId,
                apiSecret: apiSecret
            }
        })
    }

    async receiveAccounts () {
        return await axios.get(
            process.env.VUE_APP_REST_API + `google/v4/configuration/accounts`
        )
    }

    async receiveProperties (connectionId, accountId) {
        return await axios.get(
            process.env.VUE_APP_REST_API + `google/v4/configuration/${connectionId}/accounts/${accountId}/properties`
        )
    }

    async receiveMeasurements (connectionId, propertyId) {
        return await axios.get(
            process.env.VUE_APP_REST_API + `google/v4/configuration/${connectionId}/properties/${propertyId}/measurements`
        )
    }
}
